import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { KeyVal, DisputeFileUpload } from '../model/af.model';
import { Subscription } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EventService } from '../service/event.service';
import { FileDialogComponent } from '../file-dialog/file-dialog.component';
import { AttachmentUploadedEvent, UploadEvent } from '../service/events';
import { KeyValue } from '@angular/common';

@Component({
    selector: 'app-dispute-file-dialog',
    templateUrl: './dispute-file-dialog.component.html',
    styleUrls: ['./dispute-file-dialog.component.scss'],
    standalone: false
})
export class DisputeFileDialogComponent implements OnInit, OnDestroy {

  fileForm: UntypedFormGroup;
  fileDescriptionLookup: KeyVal[];

  sub: Subscription;
  inProgress: boolean = false;
  disputeFileUpload : DisputeFileUpload;

  constructor(private userService: AuthService, private _snackBar: MatSnackBar, private eventBus: EventService, public dialogRef: MatDialogRef<FileDialogComponent>, 
    private fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) private data) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
   this.disputeFileUpload = this.data.disputeFileUpload;
    this.createGroup();
    this.sub = this.eventBus.on(
      AttachmentUploadedEvent,
      (event): void => {
        this.inProgress = event.payload.inProgress;
        if (event.payload.file) {
          this._snackBar.open("Attachment uploaded successfully", "Close", {
            duration: 4000,
          });
          this.dialogRef.close();
        }
      }
    );
  }

  get submit() { return this.fileForm.get('submit') }
  get afId() { return this.fileForm.get('afId') }
  get verifyId() { return this.fileForm.get('verifyId') }

  createGroup() {
    this.fileForm = this.fb.group({
      verifyId: [this.userService.getVerifyId()],
      afId: [this.userService.getAfId(), []],
      submit: [false]
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  uploadClick(): void {
    this.eventBus.emit(new UploadEvent({}));
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  valueAscOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return a.value.localeCompare(b.value);
  }
}
